import React, { Component } from "react";
import { compose, branch } from "recompose";

let isServer = true;
export const withIsServer =
  ({ preferClientSide = false } = {}) =>
  (BaseComponent) => {
    return class WithIsServer extends Component {
      constructor() {
        super();

        this.state = {
          isServer: preferClientSide ? isServer : true,
        };
      }
      componentDidMount() {
        if (this.state.isServer) {
          isServer = false;
          this.setState({ isServer: false });
        }
      }

      render() {
        return <BaseComponent {...this.props} isServer={this.state.isServer} />;
      }
    };
  };

const branchServerClient = (server, client, options) =>
  compose(
    withIsServer(options),
    branch((props) => props.isServer, server, client)
  );

export default branchServerClient;
